import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import CookieBanner from "@/components/CookieBanner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Quote from "@/pages/Quote";
import ServicePage from "@/pages/ServicePage";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function SmoothScroll() {
  const { pathname } = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true, wheelMultiplier: 1.2 });
    window.__lenis = lenis;
    let raf = requestAnimationFrame(function loop(t) {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    });
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

const withLayout = (el) => <Layout>{el}</Layout>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <SmoothScroll />
        <Routes>
          <Route path="/" element={withLayout(<Home />)} />
          <Route path="/boka-offert" element={withLayout(<Quote />)} />
          <Route path="/tjanster/:slug" element={withLayout(<ServicePage />)} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="*" element={withLayout(<NotFound />)} />
        </Routes>
        <Toaster position="top-center" richColors />
        <CookieBanner />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
